<template>
  <div>
    <v-card-text class="mt-4 pa-0">
      <v-list id="usernames-list" class="usernames-list mb-3">
        <template v-for="(username, idx) in usernames">
          <v-list-item
            :key="username"
            @click.prevent="
              !removeUsernames
                ? $emit('select-user', username)
                : triggerRemoveUsername(username)
            "
          >
            <v-list-item-avatar class="gradient" size="35">
              <span class="white--text headline text-capitalize">{{
                username[0]
              }}</span>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">{{
                username
              }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-icon>
              <v-icon
                :large="!removeUsernames"
                :medium="removeUsernames"
                :color="removeUsernames ? 'error' : ''"
                v-text="removeUsernames ? '$delete' : '$arrow_right'"
              ></v-icon>
            </v-list-item-icon>
          </v-list-item>
          <v-divider :key="idx"></v-divider>
        </template>
        <template v-if="!removeUsernames">
          <v-list-item
            id="use-other-account"
            @click="$emit('update:window', 'login')"
          >
            <v-list-item-icon>
              <v-icon large>$add_outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                {{ $t("useOtherAccount") }}</v-list-item-title
              >
            </v-list-item-content>
            <v-list-item-icon>
              <v-icon large>$arrow_right</v-icon>
            </v-list-item-icon>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item id="remove-user-names" @click="removeUsernames = true">
            <v-list-item-icon>
              <v-icon large>$remove_outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                {{ $t("removeUserLogins") }}</v-list-item-title
              >
            </v-list-item-content>
            <v-list-item-icon>
              <v-icon large>$arrow_right</v-icon>
            </v-list-item-icon>
          </v-list-item>
          <v-divider></v-divider>
        </template>
      </v-list>
    </v-card-text>
    <v-card-actions v-if="removeUsernames" class="pa-0">
      <v-spacer></v-spacer>
      <v-btn
        id="remove-usernames-ready-button"
        color="primary"
        text
        @click="removeUsernames = false"
        >{{ $t("done") }}
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
export default {
  name: "SelectUsernames",
  props: {
    usernames: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      removeUsernames: false,
    };
  },
  methods: {
    triggerRemoveUsername(selectedUsername) {
      this.$root
        .$confirm(
          this.$t("removeUserLoginWarningHeader"),
          this.$t("removeUserLoginWarningMessage", {
            username: selectedUsername,
          })
        )
        .then((confirmResult) => {
          if (confirmResult) {
            this.removeUsername(selectedUsername);
          }
        });
    },
    removeUsername(selectedUsername) {
      const newUsernames = this.usernames.filter(
        (name) => name !== selectedUsername
      );
      this.$emit("update:usernames", newUsernames);
    },
  },
};
</script>
